export default response => {
  return response.json().then(res => {
    if (response.ok || response.headers.get("isRestricted") === "true") {
      return {
        ...res,
        status: response.status,
        isRestricted: response.headers.get("isRestricted"),
        RestrictedEids: response.headers.get("RestrictedEids")
      };
    } else {
      let error = { ...res, status: response.status };
      return Promise.reject(error);
    }
  });
};
